import styled, { css } from 'styled-components';

export interface IText {
  $size?: 'xsmall' | 'small' | 'standard' | 'large';
  $tone?: 'main' | 'alt';
  $align?: 'left' | 'center' | 'right';
}

export const Text = styled.div<IText>`
  ${({ $size }) =>
    $size === 'xsmall'
      ? css`
          font-size: 0.75rem;
        `
      : $size === 'small'
      ? css`
          font-size: 0.875rem;
        `
      : $size === 'standard'
      ? css`
          font-size: 1rem;
        `
      : $size === 'large'
      ? css`
          font-size: 1.125rem;
        `
      : undefined}

  ${({ $tone }) =>
    $tone === 'main'
      ? css`
          color: ${(props) => props.theme.color.textDark};
        `
      : $tone === 'alt'
      ? css`
          color: ${(props) => props.theme.color.textDarkLighten};
        `
      : undefined}

  ${({ $align }) =>
    $align === 'left'
      ? css`
          text-align: left;
        `
      : $align === 'center'
      ? css`
          text-align: center;
        `
      : $align === 'right'
      ? css`
          text-align: right;
        `
      : undefined}
`;
